import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';
import tpl from '../templates/captcha.html';

/*
* Captcha view controller: bind the captcha view
* with its model.
*/
export default Backbone.View.extend({
  template: _.template(tpl),

  initialize(options) {
    // Event bus
    this.vent = options.vent;
    this.signupModel = options.signupModel;
    this.options = {
      reason: options.reason || T_("You're almost there!"),
      message: options.message || T_('Verify you are human below:'),
    };
    this.$el = $(this.el);
    this.model.bind('invalid', this.onInvalid, this);
    this.model.bind('success', this.onSuccess, this);
    this.signupModel.bind('success', this.onSignupSuccess, this);
    this.signupModel.bind('error', this.onSignupError, this);
  },

  events: {
    'submit .captcha-form': 'submit',
    'click .close': 'close',
  },

  onInvalid(msg) {
    this.$el.find('#captcha_challenge').removeClass('processing');

    // Re-render
    this.render();
    this.$el
      .find('#header-welcome')
      .text(msg)
      .css({ color: 'red' });
  },

  onSuccess() {
    this.signupModel.set({
      captcha_breakpoint_id: this.model.get('captcha_breakpoint_id'),
      captcha_breakpoint_token: this.model.get('captcha_breakpoint_token'),
    });
    this.signupModel.signup();
  },

  onSignupSuccess() {
    this.vent.trigger('signup:success', {
      isEmployer: this.signupModel.isEmployer(),
    });
  },

  onSignupError(error) {
    this.vent.trigger('show:signup', {
      signupModel: this.signupModel,
      error,
    });
  },

  submit(e) {
    e.preventDefault();

    // Get ReCaptcha Response from Form
    const formData = {};
    $.each(this.$el.find('#captcha-form').serializeArray(), function() {
      formData[this.name] = this.value;
    });
    this.$el.find('#captcha_challenge').addClass('processing');

    // Check Captcha Validity
    this.model.set(
      {
        recaptcha_response_field: formData['g-recaptcha-response'],
      },
      { silent: true },
    );
    this.model.checkCaptcha();
  },

  render() {
    // Get Language from Cookie
    const re = /(?:(?:^|.*;\s*)GETAFREE_LANGUAGE\s*=\s*([^;]*).*$)|^.*$/;
    const lang = document.cookie.replace(re, '$1') || 'en';

    this.$el.html(
      this.template({
        options: this.options,
        model: this.model.toJSON(),
        language: lang,
        T_,
      }),
    );
    return this;
  },

  close() {
    this.vent.trigger('close');
  },

  /**
   * Destroy the view. Unbind all references to enable the view
   * to be garbage collected and remove the el from the DOM.
   */
  destroy() {
    this.model.unbind('invalid', this.onInvalid, this);
    this.model.unbind('success', this.onSuccess, this);
    this.signupModel.unbind('success', this.onSignupSuccess, this);
    this.signupModel.unbind('error', this.onSignupError, this);
    this.remove();
  },
});
